export default {
  assistantSteps: [],
  currentStepIndex: 0,
};
